"use strict";
var appn;
(function (appn) {
    let RESTFormat;
    (function (RESTFormat) {
        RESTFormat["json"] = "Json";
        RESTFormat["xml"] = "Xml";
        RESTFormat["urlEncoded"] = "UrlEncoded";
        RESTFormat["rawJson"] = "RawJson";
        RESTFormat["rawXml"] = "RawXml";
    })(RESTFormat = appn.RESTFormat || (appn.RESTFormat = {}));
    let UserType;
    (function (UserType) {
        UserType["full"] = "Full";
        UserType["premium"] = "Premium";
        UserType["standard"] = "Standard";
        UserType["edge"] = "Edge";
        UserType["pro"] = "Pro";
    })(UserType = appn.UserType || (appn.UserType = {}));
    let RowSortType;
    (function (RowSortType) {
        RowSortType["asc"] = "Asc";
        RowSortType["desc"] = "Desc";
        RowSortType["none"] = "None";
    })(RowSortType = appn.RowSortType || (appn.RowSortType = {}));
    let ScreenType;
    (function (ScreenType) {
        ScreenType["form"] = "Form";
        ScreenType["listing"] = "Listing";
        ScreenType["detail"] = "Detail";
        ScreenType["iconBoard"] = "IconBoard";
        ScreenType["mapping"] = "Mapping";
    })(ScreenType = appn.ScreenType || (appn.ScreenType = {}));
})(appn || (appn = {}));
